/**
 * 建築タイプフィルタの選択肢（reservation-form と部屋タイプ予約ブラウズで共有）。
 * value は ArchitectureType.seriesShortName（ARC/BEE/MOSS/RAY/SKY）と、Selection 系全体を
 * 表す特殊値 "Selection"。BE 側 SELECTION_ARCHITECTURE_KEY（core-system の
 * domain/rules/architectureTypeFilter.ts）と文字列を一致させること。
 */
export const SELECTION_ARCHITECTURE_VALUE = "Selection";

export type ArchitectureFilterOption = { value: string; label: string };

export const ARCHITECTURE_FILTER_OPTIONS: ArchitectureFilterOption[] = [
  { value: "BEE", label: "BEE（2-3人）" },
  { value: "MOSS", label: "MOSS（3-4人）" },
  { value: "SKY", label: "SKY（3-4人）" },
  { value: "RAY", label: "RAY（2-3人）" },
  { value: "ARC", label: "ARC（3-5人）" },
  { value: SELECTION_ARCHITECTURE_VALUE, label: "Selection（4-8人）" },
];
